import { TranslateDto } from '@app/data/dtos/content-translator/content-translator.dto';

import { MapFromFn } from '@mercadona/common/public';

export const mapContentTranslator: MapFromFn<TranslateDto, string> = (value) => value.text;
